<template>
	<!-- Returns objects, multiple selection is possible, displays chips -->
	<!-- Solo selection is possible -->
	<!-- EXAMPLE USE
		<autocomplete
			:items="formItems.mandator"
			label="Mandator"
			:model.sync="formState.selectedMandators"
		>
		</autocomplete>
	-->
	<div>
		<v-autocomplete
			v-show="show"
			v-model="modelLocal"
			:items="items"
			:error-count="errorCount"
			:item-text="itemText"
			:error-messages="errorMessage"
			:search.sync="search"
			hide-selected
			:label="label"
			:multiple="!solo"
			persistent-hint
			chips
			:solo="solo"
			return-object
			:disabled="disabled"
			@change="selectedValueEmit"
		/>
	</div>
</template>

<script>
export default {
	name: 'AutocompleteObjects',
	props: {
		show: {
			type: Boolean,
			default: true,
		},
		model: {
			required: true,
		},
		items: {
			tpye: Array,
			required: true,
			default: ['could not be loaded'],
		},
		label: {
			type: String,
			required: true,
		},
		errorCount: {
			type: Number,
			default: 0,
		},
		errorMessage: {
			type: String,
			default: '',
		},
		search: {
			default: null,
		},
		solo: {
			type: Boolean,
			default: false,
		},
		itemText: {},
		disabled: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			modelLocal: this.model,
		}
	},
	methods: {
		selectedValueEmit() {
			this.$emit('update:model', this.modelLocal)
		},
	},
}
</script>

<style>

</style>
